import React from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const RouteErrorFallback = ({ error, resetError }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center">
    <div className="bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-800 rounded-lg p-8 max-w-lg w-full">
      <h2 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
        Une erreur est survenue sur cette page
      </h2>
      <p className="text-sm text-red-600 dark:text-red-400 mb-4">
        L'erreur a été signalée automatiquement.
      </p>
      <div className="flex gap-3 justify-center">
        <button
          onClick={resetError}
          className="px-4 py-2 bg-primary text-white rounded-md text-sm hover:bg-primary/90"
        >
          Réessayer
        </button>
        <button
          onClick={() => window.location.href = '/dashboard'}
          className="px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-md text-sm hover:bg-gray-200 dark:hover:bg-gray-700"
        >
          Retour au tableau de bord
        </button>
      </div>
    </div>
  </div>
);

export const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();

  return (
    <Sentry.ErrorBoundary
      key={location.pathname}
      fallback={RouteErrorFallback}
      beforeCapture={(scope) => {
        scope.setTag('error_boundary', 'route_level');
        scope.setTag('route', location.pathname);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
